import { Link } from "react-router-dom";
import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      subtitle="The rules of the road"
      lastUpdated="February 14, 2026"
    >
      <p>
        These Terms of Service ("Terms") govern your access to and use of platebuddies.com and the
        related products operated by HappyPlate LLC ("HappyPlate," "we," "our"). By using the site or
        purchasing a product, you agree to these Terms.
      </p>

      <h2>1. Who can use Plate Buddies</h2>
      <p>
        You must be at least 18 years old (or the legal age of majority in your jurisdiction) to make a
        purchase or submit a pilot program application. The product is designed for use by children ages
        2–7 with parent or guardian supervision.
      </p>

      <h2>2. Orders, pricing, and payment</h2>
      <ul>
        <li>All prices are in U.S. dollars. Sales tax and shipping are calculated at checkout where applicable.</li>
        <li>We reserve the right to refuse or cancel any order — for example, in cases of suspected fraud, pricing errors, or stock issues. If we cancel your order, we'll refund any payment in full.</li>
        <li>Promotional codes (e.g. WELCOME10, FAMILY15, EARLYBIRD, PILOT) are limited to the rules described at checkout.</li>
      </ul>

      <h2>3. Custom Buddy creations</h2>
      <ul>
        <li>The AI Buddy Generator produces illustrations from prompts you provide. Output is generated by Google's Gemini image model.</li>
        <li><strong>Do not submit prompts that include real children's faces, copyrighted characters, or content that's sexual, hateful, or violent.</strong> We may refuse to print orders that violate these rules.</li>
        <li>You retain the right to use your generated Buddies for personal, non-commercial purposes. HappyPlate retains rights to its underlying brand, characters, and product designs.</li>
      </ul>

      <h2>4. Shipping</h2>
      <p>
        We currently ship to the United States. Standard shipping arrives in 3–5 business days; Express
        in 1–2 business days. Shipping is free on orders over $50. Custom Buddy prints typically ship
        within 5–7 business days. Once a package leaves our studio, delivery times are subject to the
        carrier (USPS, UPS, etc.) and beyond our control.
      </p>

      <h2>5. Returns & refunds</h2>
      <p>
        See our <Link to="/refunds">Refund Policy</Link> for the complete rules.
      </p>

      <h2>6. Pilot program</h2>
      <p>
        The pilot program is selective and limited to 10 families per cohort. Applying does not guarantee
        acceptance. Accepted families receive a private code for a free Premium Kit (you only pay
        shipping) in exchange for ongoing, honest feedback. We may publish anonymized highlights of pilot
        feedback in marketing materials; we will not share your contact information without consent.
      </p>

      <h2>7. Your account & data</h2>
      <p>
        Your saved Buddies, cart, and access entitlements are stored locally in your browser and on our
        servers. See our <Link to="/privacy">Privacy Policy</Link> for full details.
      </p>

      <h2>8. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Reverse-engineer, scrape, or interfere with the site or its APIs.</li>
        <li>Use the AI Buddy Generator to produce inappropriate, harmful, or infringing content.</li>
        <li>Resell our products outside of an approved retail relationship.</li>
      </ul>

      <h2>9. Intellectual property</h2>
      <p>
        "Plate Buddies," all character designs, illustrations, copy, and the underlying software are the
        property of HappyPlate LLC. You may not reproduce or distribute them without written permission.
      </p>

      <h2>10. Disclaimers</h2>
      <p>
        Plate Buddies is a playful product designed to make mealtime more fun. It is not a medical
        device, nutrition program, or feeding-therapy intervention, and is not intended to diagnose,
        treat, or cure any condition. Always consult a qualified pediatrician or feeding specialist for
        medical advice.
      </p>
      <p>
        The site and product are provided "as is." To the maximum extent permitted by law, HappyPlate
        disclaims all warranties, express or implied, including merchantability and fitness for a
        particular purpose.
      </p>

      <h2>11. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, HappyPlate's total liability for any claim arising out of
        these Terms or your use of the product is limited to the amount you paid us for the product giving
        rise to the claim in the 12 months preceding the claim.
      </p>

      <h2>12. Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of <strong>Oklahoma, United States</strong>,
        without regard to conflict-of-law principles. Any dispute will be resolved in the state or federal
        courts located in Oklahoma.
      </p>

      <h2>13. Changes to these Terms</h2>
      <p>
        We may update these Terms occasionally. Material changes will be reflected by an updated "Last
        updated" date and, where appropriate, notice by email.
      </p>

      <h2>14. Contact</h2>
      <p>
        HappyPlate LLC<br />
        Oklahoma, United States<br />
        Email: <a href="mailto:hello@platebuddies.com">hello@platebuddies.com</a>
      </p>
    </LegalPage>
  );
}
